module.exports = __webpack_public_path__ + "img/metamanage.255674e2.svg";